var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4848 2H3.51515C2.67836 2 2 2.67836 2 3.51515V20.4848C2 21.3216 2.67836 22 3.51515 22H20.4848C21.3216 22 22 21.3216 22 20.4848V3.51515C22 2.67836 21.3216 2 20.4848 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.93939C8.88751 5.93935 6.28098 8.29702 5.96973 11.3939H10.1818V10.4848C10.1818 10.3175 10.3175 10.1818 10.4849 10.1818H13.5152C13.6825 10.1818 13.8182 10.3175 13.8182 10.4848V13.5152C13.8182 13.6825 13.6825 13.8182 13.5152 13.8182H10.4849C10.3175 13.8182 10.1818 13.6825 10.1818 13.5152V12.6061H5.96973C6.29657 15.8581 9.14321 18.2652 12.4043 18.0471C15.6655 17.829 18.1663 15.0643 18.0572 11.7977C17.9481 8.53113 15.2684 5.93943 12 5.93939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUber);
export default __webpack_public_path__ + "static/media/uber.37dc1e4f4942e152f2f2b0d2d78c52f2.svg";
export { ForwardRef as ReactComponent };